import { formatNaira } from "@/utils/currencyUtils";
import { Notification } from "./types";

// Helper function to format notification messages properly
export const formatNotificationMessage = (
  notification: Notification,
): Notification => {
  // Handle cashout notifications
  if (
    notification.type === "cashout_completed" ||
    notification.type === "cashout_submitted" ||
    notification.type === "cashout_updated"
  ) {
    // Extract amount from notification data or message
    let amount = notification.data?.amount;

    console.log(
      "Processing notification:",
      notification.type,
      "amount from data:",
      amount,
    );

    if (!amount && notification.message) {
      // Try to extract amount from message
      const amountMatch = notification.message.match(/₦([\d,.]+)/);
      if (amountMatch) {
        amount = parseFloat(amountMatch[1].replace(/,/g, ""));
        console.log("Extracted amount from message:", amount);
      }
    }

    if (amount && typeof amount === "number") {
      // Check if the amount looks like it was incorrectly converted (less than 10)
      // If so, multiply by 100 to get the correct naira amount
      const correctedAmount = amount < 10 ? amount * 100 : amount;
      console.log(
        "Original amount:",
        amount,
        "Corrected amount:",
        correctedAmount,
      );

      // Ensure the amount is properly formatted as naira
      const formattedAmount = formatNaira(correctedAmount);
      console.log("Formatted amount:", formattedAmount);

      // Update the message with properly formatted amount
      let updatedMessage = notification.message;
      if (updatedMessage.includes("₦")) {
        updatedMessage = updatedMessage.replace(/₦[\d,.]+/, formattedAmount);
      }

      return {
        ...notification,
        message: updatedMessage,
        data: {
          ...notification.data,
          amount: correctedAmount,
        },
      };
    }
  }

  // Handle fan club notifications
  if (
    notification.type === "fan_club_new_member" ||
    notification.type === "fan_club_subscription_success"
  ) {
    let amount = notification.data?.amount;

    if (amount && typeof amount === "number") {
      // Convert from kobo to naira (divide by 100)
      const nairaAmount = amount / 100;
      const formattedAmount = formatNaira(nairaAmount);

      // Update the message with properly formatted amount
      let updatedMessage = notification.message;
      if (updatedMessage.includes("₦")) {
        updatedMessage = updatedMessage.replace(/₦[\d,.]+/, formattedAmount);
      }

      return {
        ...notification,
        message: updatedMessage,
        data: {
          ...notification.data,
          amount: nairaAmount,
          formattedAmount,
        },
      };
    }
  }

  return notification;
};
